define.alias("shared/utils/formatters/ig-post-from-dynamo", "settings/utils/formatters/ig-post-from-dynamo");